//@ts-expect-error
const configFromServer = window.__CONFIG__ ?? { ENVIRONMENT: 'dev' }
const ENVIRONMENT = configFromServer.ENVIRONMENT
export interface Config {
  CHANNEL_API_BASE_URL: string,
  ENTRA_ID_LOGIN_URL: string,
  ENVIRONMENT: string,
  EVENT_API_BASE_URL: string,
  EVENT_FEED_SIGNALR_URL: string,
  GROCERY_API_BASE_URL: string,
  GROCERY_STOCK_API_BASE_URL: string,
  GROCERY_STOCK_FEED_SIGNALR_URL: string,
  LOGIN_URL: string,
  PRODUCTS_API_BASE_URL: string,
  STORE_API_NEW_BASE_URL: string,
  STORE_API_BASE_URL: string,
  UNMANNED_API_BASE_URL: string,
}

const getAppConfig = (): Config => {
  switch (ENVIRONMENT) {
    case 'test':
      return {
        CHANNEL_API_BASE_URL: 'https://api-dev.icapronto.se/svc-channel',
        ENTRA_ID_LOGIN_URL: 'https://api-dev.icanow.se',
        ENVIRONMENT,
        EVENT_API_BASE_URL: 'https://api-dev.icapronto.se/app-store-event',
        EVENT_FEED_SIGNALR_URL: 'https://api-dev.icapronto.se/app-event/hubs/events',
        GROCERY_API_BASE_URL: 'https://api-dev.icanow.se',
        GROCERY_STOCK_API_BASE_URL: 'https://api-dev.icanow.se',
        GROCERY_STOCK_FEED_SIGNALR_URL: 'https://api-dev.icanow.se/grocery-stock/hubs/groceries',
        LOGIN_URL: 'https://authentication-testing.icapronto.se/user/login',
        PRODUCTS_API_BASE_URL: 'https://api-dev.icapronto.se/app-food',
        STORE_API_NEW_BASE_URL: 'https://api-dev.icanow.se',
        STORE_API_BASE_URL: 'https://api-dev.icapronto.se/app-store',
        UNMANNED_API_BASE_URL: 'https://api-dev.icanow.se',
      }
    case 'stage':
      return {
        CHANNEL_API_BASE_URL: 'https://api-ver.icapronto.se/svc-channel',
        ENTRA_ID_LOGIN_URL: 'https://api-ver.icanow.se',
        ENVIRONMENT,
        EVENT_API_BASE_URL: 'https://api-ver.icapronto.se/app-store-event',
        EVENT_FEED_SIGNALR_URL: 'https://api-ver.icapronto.se/app-event/hubs/events',
        GROCERY_API_BASE_URL: 'https://api-ver.icanow.se',
        GROCERY_STOCK_API_BASE_URL: 'https://api-ver.icanow.se',
        GROCERY_STOCK_FEED_SIGNALR_URL: 'https://api-ver.icanow.se/grocery-stock/hubs/groceries',
        LOGIN_URL: 'https://authentication-staging.icapronto.se/user/login',
        PRODUCTS_API_BASE_URL: 'https://api-ver.icapronto.se/app-food',
        STORE_API_NEW_BASE_URL: 'https://api-ver.icanow.se',
        STORE_API_BASE_URL: 'https://api-ver.icapronto.se/app-store',
        UNMANNED_API_BASE_URL: 'https://api-ver.icanow.se',
      }
    case 'prod':
      return {
        CHANNEL_API_BASE_URL: 'https://api.icapronto.se/svc-channel',
        ENTRA_ID_LOGIN_URL: 'https://api.icanow.se',
        ENVIRONMENT,
        EVENT_API_BASE_URL: 'https://api.icapronto.se/app-store-event',
        EVENT_FEED_SIGNALR_URL: 'https://api.icapronto.se/app-event/hubs/events',
        GROCERY_API_BASE_URL: 'https://api.icanow.se',
        GROCERY_STOCK_API_BASE_URL: 'https://api.icanow.se',
        GROCERY_STOCK_FEED_SIGNALR_URL: 'https://api.icanow.se/grocery-stock/hubs/groceries',
        LOGIN_URL: 'https://authentication.icapronto.se/user/login',
        PRODUCTS_API_BASE_URL: 'https://api.icapronto.se/app-food',
        STORE_API_NEW_BASE_URL: 'https://api.icanow.se',
        STORE_API_BASE_URL: 'https://api.icapronto.se/app-store',
        UNMANNED_API_BASE_URL: 'https://api.icanow.se',
      }
    default: // local
      return {
        CHANNEL_API_BASE_URL: 'http://localhost:8559',
        ENTRA_ID_LOGIN_URL: 'http://localhost:5234',
        ENVIRONMENT,
        EVENT_API_BASE_URL: 'http://localhost:8552',
        EVENT_FEED_SIGNALR_URL: 'https://api-dev.icapronto.se/app-event/hubs/events',
        GROCERY_API_BASE_URL: 'http://localhost:5233',
        GROCERY_STOCK_API_BASE_URL: 'http://localhost:5075',
        GROCERY_STOCK_FEED_SIGNALR_URL: 'http://localhost:5075/groceries',
        LOGIN_URL: 'https://authentication-testing.icapronto.se/user/login',
        PRODUCTS_API_BASE_URL: 'http://localhost:8556',
        STORE_API_NEW_BASE_URL: 'http://localhost:5137',
        STORE_API_BASE_URL: 'http://localhost:8553',
        UNMANNED_API_BASE_URL: 'http://localhost:5182',
      }
  }
}

const config = getAppConfig()

export { config }
export default config